import React from 'react';

const Payment = ({ rowData, access }) => {
    const contractor = rowData.contractor;  
    return (
        <span>  
            {contractor ? (  
                <>  
                    کل:<br/>
                        {rowData.current_phase ?
                        Number.isNaN(Number(rowData.current_phase.price))
                            ? rowData.current_phase.price
                            : Number(rowData.current_phase.price).toLocaleString()
                        : Number.isNaN(Number(rowData.price))
                            ? rowData.price
                            : Number(rowData.price).toLocaleString()}<br/>
                    <span style={{color: 'blue'}}>{access === "manager" ? "سهم پیمانکار:" : "سهم شما:"}</span><br/>
                    <span style={{color: 'blue'}}>
                        {rowData.current_phase ?
                        Number.isNaN(Number(rowData.current_phase.price))
                            ? rowData.current_phase.price - ((rowData.contractor.commission_percentage * rowData.current_phase.price) / 100)
                            : Number(rowData.current_phase.price - ((rowData.contractor.commission_percentage * rowData.current_phase.price) / 100)).toLocaleString()
                        : Number.isNaN(Number(rowData.price))
                            ? rowData.price - ((rowData.contractor.commission_percentage * rowData.price) / 100)
                            : Number(rowData.price - ((rowData.contractor.commission_percentage * rowData.price) / 100)).toLocaleString()}<br/>
                    </span>
                </>  
            ) : (  
                <>
                    کل:<br/>
                        {rowData.current_phase ?
                        Number.isNaN(Number(rowData.current_phase.price))
                            ? rowData.current_phase.price
                            : Number(rowData.current_phase.price).toLocaleString()
                        : Number.isNaN(Number(rowData.price))
                            ? rowData.price
                            : Number(rowData.price).toLocaleString()}<br/>
                    <span style={{color: 'blue'}}>{access === "manager" ? "سهم پیمانکار:" : "سهم شما:"}</span><br/>
                    <span style={{color: 'blue'}}>
                        {rowData.current_phase ?
                        Number.isNaN(Number(rowData.current_phase.price))
                            ? rowData.current_phase.price - ((rowData.commission_percentage * rowData.current_phase.price) / 100)
                            : Number(rowData.current_phase.price - ((rowData.commission_percentage * rowData.current_phase.price) / 100)).toLocaleString()
                        : Number.isNaN(Number(rowData.price))
                            ? rowData.price - ((rowData.commission_percentage * rowData.price) / 100)
                            : Number(rowData.price - ((rowData.commission_percentage * rowData.price) / 100)).toLocaleString()}<br/>
                    </span>
                </>
            )}  
        </span>  
    );
}

export default Payment;